// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.level3--HvDO1 {
  position: relative;
  display: flex;
  align-items: center;
  -moz-column-gap: 4px;
       column-gap: 4px;
  row-gap: 0;
  flex-wrap: wrap;
}[dir] .level3--HvDO1 {
  padding: 5px 0 0 0;
  margin-bottom: 0;
}

.level3--HvDO1 > ul {
  flex-basis: 100%;
}

.indicatorPill--VZn5M {
  display: flex;
  align-items: center;
  gap: 4px;
  flex: 1;
}

[dir] .indicatorPill--VZn5M {
  border-radius: 4px;
  padding: 5px 8px;
  border: 1px solid #c3c3c3;
  background: white;
}

.level3--HvDO1::before {
  content: '';
  position: absolute;
  top: 20px;
  width: 14px;
  height: 2px;
}

[dir] .level3--HvDO1::before {
  background: var(--tree-color, rgba(0, 0, 0, 0.2));
}

[dir=ltr] .level3--HvDO1::before {
  left: -14px;
}

[dir=rtl] .level3--HvDO1::before {
  right: -14px;
}

.level3--HvDO1:last-of-type::after {
  content: '';
  position: absolute;
  top: 22px;
  bottom: -2px;
  width: 4px;
}

[dir] .level3--HvDO1:last-of-type::after {
  background: var(--tree-mask-bg, #f5f5f5);
}

[dir=ltr] .level3--HvDO1:last-of-type::after {
  left: -14px;
}

[dir=rtl] .level3--HvDO1:last-of-type::after {
  right: -14px;
}

.level3Item--TMLVF {
  white-space: break-spaces;
}

.appMenuLevel3Expand--beM1A {
  flex-shrink: 0;
}

[dir] .appMenuLevel3Expand--beM1A {
  margin: 0;
}

.expandButton--_74LK {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #000;
  font-size: 18px;
  font-weight: 300;
  line-height: 1;
}

[dir] .expandButton--_74LK {
  border-radius: 0;
  cursor: pointer;
  border: none;
  padding: 0 0 1px 0;
  background: transparent;
}

.expandButton--_74LK:hover {
  opacity: 0.7;
}

.expandButtonActive--cTNP0 {
  color: #fff;
}

[dir] .expandButtonActive--cTNP0 {
  background: rgb(var(--selected_color));
  border-radius: 50%;
}

.disabled--H79Oy {
  opacity: 0.5;
}

[dir] .disabled--H79Oy {
  cursor: not-allowed;
}

.selected--JfTSw {
  font-weight: 700;
}

[dir] .selected--JfTSw {
  background: rgba(var(--selected_color), 0.25) !important;
  border: 1px solid rgb(var(--selected_color)) !important;
}
`, "",{"version":3,"sources":["webpack://./src/js/components/SubjectPickerMenu/SubComponents/Indicators/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAGlB,aAAa;EACb,mBAAmB;EACnB,oBAAe;OAAf,eAAe;EACf,UAAU;EACV,eAAe;AACjB,CATA;EAEE,kBAAkB;EAClB,gBAAgB;AAMlB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAGE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EAGR,OAAO;AACT;;AATA;EACE,kBAAkB;EAClB,gBAAgB;EAIhB,yBAAyB;EACzB,iBAAiB;AAEnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAElB,SAAS;EACT,WAAW;EACX,WAAW;AAEb;;AARA;EAOE,iDAAiD;AACnD;;AARA;EAGE,WAAW;AAKb;;AARA;EAGE,YAAW;AAKb;;AAEA;EACE,WAAW;EACX,kBAAkB;EAElB,SAAS;EACT,YAAY;EACZ,UAAU;AAEZ;;AARA;EAOE,wCAAwC;AAC1C;;AARA;EAGE,WAAW;AAKb;;AARA;EAGE,YAAW;AAKb;;AAKA;EACE,yBAAyB;AAC3B;;AAEA;EAEE,cAAc;AAChB;;AAHA;EACE,SAAS;AAEX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EAEZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAGhB,cAAc;AAGhB;;AAfA;EAME,gBAAgB;EAIhB,eAAe;EACf,YAAY;EAEZ,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd;;AAEA;EAEE,WAAW;AAEb;;AAJA;EACE,sCAAsC;EAEtC,kBAAkB;AACpB;;AAEA;EAEE,YAAY;AACd;;AAHA;EACE,mBAAmB;AAErB;;AAEA;EACE,gBAAgB;AAGlB;;AAJA;EAEE,wDAAwD;EACxD,uDAAuD;AACzD","sourcesContent":[".level3 {\n  position: relative;\n  padding: 5px 0 0 0;\n  margin-bottom: 0;\n  display: flex;\n  align-items: center;\n  column-gap: 4px;\n  row-gap: 0;\n  flex-wrap: wrap;\n}\n\n.level3 > ul {\n  flex-basis: 100%;\n}\n\n.indicatorPill {\n  border-radius: 4px;\n  padding: 5px 8px;\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border: 1px solid #c3c3c3;\n  background: white;\n  flex: 1;\n}\n\n.level3::before {\n  content: '';\n  position: absolute;\n  left: -14px;\n  top: 20px;\n  width: 14px;\n  height: 2px;\n  background: var(--tree-color, rgba(0, 0, 0, 0.2));\n}\n\n.level3:last-of-type::after {\n  content: '';\n  position: absolute;\n  left: -14px;\n  top: 22px;\n  bottom: -2px;\n  width: 4px;\n  background: var(--tree-mask-bg, #f5f5f5);\n}\n\n.selectedItem {\n}\n\n.level3Item {\n  white-space: break-spaces;\n}\n\n.appMenuLevel3Expand {\n  margin: 0;\n  flex-shrink: 0;\n}\n\n.expandButton {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 0;\n  color: #000;\n  font-size: 18px;\n  font-weight: 300;\n  cursor: pointer;\n  border: none;\n  line-height: 1;\n  padding: 0 0 1px 0;\n  background: transparent;\n}\n\n.expandButton:hover {\n  opacity: 0.7;\n}\n\n.expandButtonActive {\n  background: rgb(var(--selected_color));\n  color: #fff;\n  border-radius: 50%;\n}\n\n.disabled {\n  cursor: not-allowed;\n  opacity: 0.5;\n}\n\n.selected {\n  font-weight: 700;\n  background: rgba(var(--selected_color), 0.25) !important;\n  border: 1px solid rgb(var(--selected_color)) !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"level3": `level3--HvDO1`,
	"indicatorPill": `indicatorPill--VZn5M`,
	"level3Item": `level3Item--TMLVF`,
	"appMenuLevel3Expand": `appMenuLevel3Expand--beM1A`,
	"expandButton": `expandButton--_74LK`,
	"expandButtonActive": `expandButtonActive--cTNP0`,
	"disabled": `disabled--H79Oy`,
	"selected": `selected--JfTSw`
};
export default ___CSS_LOADER_EXPORT___;
